export default "__VITE_ASSET__PDeuxUwA__"